"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _MembershipTypes = _interopRequireDefault(require("../constants/MembershipTypes"));

var _Workspace = _interopRequireDefault(require("../records/Workspace"));

var _handleActions;

var initialState = new _immutable.Map({
  stagedWorkspace: new _Workspace.default(),
  teamSearchTerm: '',
  userSearchTerm: ''
});

function handleSelectDeselect(state, action, setFunction) {
  var _action$payload = action.payload,
      id = _action$payload.id,
      memberType = _action$payload.memberType;
  var workspace = state.get('stagedWorkspace');
  var fieldToUpdate = memberType === _MembershipTypes.default.TEAM ? 'teamMemberIds' : 'userMemberIds';
  return state.merge({
    stagedWorkspace: workspace.update(fieldToUpdate, function (fieldSet) {
      return setFunction(id, fieldSet);
    })
  });
}

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_WorkspaceActions.WorkspaceActionTypes.STAGE_WORKSPACE, _WorkspaceActions.WorkspaceActionTypes.START_RENAME_WORKSPACE), function (state, action) {
  var workspace = action.payload.workspace;
  return state.merge({
    stagedWorkspace: workspace
  });
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.UPDATE_STAGED_WORKSPACE, function (state, action) {
  var properties = action.payload.properties;
  var workspace = state.get('stagedWorkspace');
  return state.merge({
    stagedWorkspace: workspace.merge((0, _immutable.Map)(properties).filter(function (value, key) {
      return workspace.has(key);
    }))
  });
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.SELECT_MEMBER, function (state, action) {
  var newState = handleSelectDeselect(state, action, function (id, set) {
    return set.add(id);
  });
  var _action$payload2 = action.payload,
      id = _action$payload2.id,
      memberType = _action$payload2.memberType,
      teamMappings = _action$payload2.teamMappings;

  if (memberType === _MembershipTypes.default.TEAM) {
    var userIdsToClear = (0, _immutable.Set)(teamMappings.filter(function (teamId) {
      return teamId === id;
    }).keys());
    var workspace = newState.get('stagedWorkspace');
    return newState.merge({
      stagedWorkspace: workspace.update('userMemberIds', function (userMemberIds) {
        return userMemberIds.filterNot(function (userId) {
          return userIdsToClear.has(userId);
        });
      })
    });
  } else {
    return newState;
  }
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.DESELECT_MEMBER, function (state, action) {
  return handleSelectDeselect(state, action, function (id, set) {
    return set.remove(id);
  });
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.SEARCH_USERS, function (state, action) {
  var searchTerm = action.payload.searchTerm;
  return state.set('userSearchTerm', searchTerm);
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.SEARCH_TEAMS, function (state, action) {
  var searchTerm = action.payload.searchTerm;
  return state.set('teamSearchTerm', searchTerm);
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_WorkspaceActions.WorkspaceActionTypes.CANCELLED_WORKSPACE_CREATION, _WorkspaceActions.CreateWorkspaceActionTypes.SUCCESS, _WorkspaceActions.CreateWorkspaceActionTypes.FAILURE, _WorkspaceActions.AddWorkspaceMembersActionTypes.SUCCESS, _WorkspaceActions.AddWorkspaceMembersActionTypes.FAILURE, _WorkspaceActions.WorkspaceActionTypes.CANCELLED_ASSIGN_MEMBERS, _WorkspaceActions.EditWorkspaceActionTypes.FAILURE, _WorkspaceActions.EditWorkspaceActionTypes.SUCCESS, _WorkspaceActions.WorkspaceActionTypes.CANCELLED_RENAME_WORKSPACE), function () {
  return initialState;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;